<template>
  <div class="statistics">
    <div v-if="isAuthorised">
      <b-card-group deck>
        <b-card :header="trans('perYear')">
          <b-table striped hover
                   :items="yearlyItems"
                   :fields="yearlyFields"
                   :busy="isYearlyLoading"
                   show-empty
                   :emptyText="trans('noData')"

          >
            <template slot="price" slot-scope="row">
              {{ row.item.price |currency }}
            </template>
          </b-table>
        </b-card>

        <b-card :header="trans('perMonth')">
          <b-table striped hover
                   :items="monthlyItems"
                   :fields="monthlyFields"
                   :busy="isMonthlyLoading"
                   show-empty
                   :emptyText="trans('noData')"
          >
            <template slot="yearmonth" slot-scope="row">
              {{ row.item.month.padStart(2, 0) }} / {{ row.item.year }}
            </template>

            <template slot="price" slot-scope="row">
              {{ row.item.price |currency }}
            </template>
          </b-table>
        </b-card>
      </b-card-group>

      <b-card-group deck>
        <b-card :header="trans('graph')">
          <chart v-if="!isMonthlyLoading && monthlyItems.length > 0"
                 :chart-data="chartData"
                 :options="chartOptions"
          />
          <div v-else class="text-center">{{ trans('noData') }}</div>
        </b-card>
      </b-card-group>
    </div>
    <p  v-else
        class="notfound stat-tab"
    >
      {{ $t('_unauthorised') }}
    </p>
  </div>
</template>

<script>
import CommonApi from '@/api/commonApi'
import Chart from '@/components/frontoffice/chart.vue'
import formatter from '@/components/global/mixins/formatterMethods'

export default {
  components: { Chart },

  mixins: [formatter],

  data() {
    return {
      commonApi: new CommonApi(),
      yearlyItems: null,
      monthlyItems: null,
      yearlyFields: [
        { key: 'year', label: this.trans('year')},
        { key: 'nbBookings', label: this.trans('nbBookings')},
        { key: 'price', label: this.trans('price')},
        { key: 'nbOvernights', label: this.trans('nbOvernights')}
      ],
      monthlyFields: [
        { key: 'yearmonth', label: this.trans('month'), class: 'text-nowrap'},
        { key: 'nbBookings', label: this.trans('nbBookings')},
        { key: 'price', label: this.trans('price')},
        { key: 'nbOvernights', label: this.trans('nbOvernights')}
      ],
      isMonthlyLoading: true,
      isYearlyLoading: true,
      chartData: null,
      chartOptions: null,
      isAuthorised: true
    }
  },

  mounted () {
    this.$events.listen('showTabStats', eventData => this.$events.fire('updateChart', eventData));

    // Yearly stats
    this.commonApi.bookingsStats('year').then(response => {
      if (response.data.success) {
        this.yearlyItems = response.data.data
        this.isYearlyLoading = false
      }
    })

    // Monthly Stats
    this.commonApi.bookingsStats('month').then(response => {
      if (response.data.success) {
        this.monthlyItems = response.data.data
        this.buildChart()
        this.isMonthlyLoading = false
      } else {
        this.isAuthorised = false
      }
    })
  },

  methods: {
    buildChart () {
      let labels = []
      let data = {
        nbBookings: [],
        nbNights: [],
        nbOvernights: [],
        nbRooms: []
      }

      for (let item of this.monthlyItems) {
        labels.push(item.month.padStart(2, 0) + '/' + item.year)

        for (let key in item) {
          if (item.hasOwnProperty(key)) {
            if (Object.keys(data).indexOf(key) !== -1) {
              data[key].push(item[key])
            }
          }
        }
      }

      this.chartData = {
        labels: labels,
        datasets: [
          {
            label: this.trans('nbBookings'),
            data: data.nbBookings,
            fill: false,
            borderColor: '#ff6000'
          },
          {
            label: this.trans('nbNights'),
            data: data.nbNights,
            fill: false,
            borderColor: '#0066cc'
          },
          {
            label: this.trans('nbOvernights'),
            data: data.nbOvernights,
            fill: false,
            borderColor: '#990000'
          },
          {
            label: this.trans('nbRooms'),
            data: data.nbRooms,
            fill: false,
            borderColor: '#336600'
          }
        ]
      }

      this.chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
      }
    },

    trans(label) {
      return this.$t('stats.' + label)
    }
  }
}
</script>
